import { TabMenu, TabMenuData } from "../../../components/tabMenu/TabMenu";

export const EcoEfficiencyTabMenuV2 = () => {
  const tabMenu: TabMenuData[] = [
    {
      pathname: "/eco-efficiency/dashboard",
      name: "Dashboard",
    },
    { pathname: "/eco-efficiency/add-data", name: "Add-Data" },
  ];

  return <TabMenu tabMenuData={tabMenu} />;
};
